export default function UtilsService($q, $state, $timeout, DataConst) {
	"ngInject";

	const utils = {
		isEmpty: (value) => (
			angular.isUndefined(value) || value === null || value === ""
		),
		toArray: (obj) => (
			obj && !angular.isArray(obj) ? [obj] : obj
		),
		cloneArray: (list = []) => (
			[].concat(list)
		),
		removeItem: (item, list) => {
			let index = list.indexOf(item);
			if (index !== -1) {
				list.splice(index, 1);
			}
		},
		queue: (fn, delay = 100) => {
			let timer = null;
			return () => {
				$timeout.cancel(timer);
				timer = $timeout(fn, delay);
			};
		},

		getOrgStateName: (org) => (
			org.type.toLowerCase()
		),
		getOrgStateParams: (org) => (
			{[`${org.type.toLowerCase()}Id`]: org.id}
		),
		goOrgState: (org) => {
			$state.go(utils.getOrgStateName(org), utils.getOrgStateParams(org));
		},

		containsOrg: (orgs, org) => (
			utils.indexOfOrg(orgs, org) !== -1
		),
		indexOfOrg: (orgs, org) => {
			let index = orgs.indexOf(org);
			if (index !== -1) {
				for (let i = 0; i < orgs.length; i++) {
					let current = orgs[i];
					if (current === org || (current.id === org.id && current.type === org.type)) {
						index = i;
						break;
					}
				}
			}
			return index;
		},

		uniqueOrgs: (orgs) => {
			let results = [];
			orgs.forEach((org) => {
				if (!utils.containsOrg(results, org)) {
					results.push(org);
				}
			});
			return results;
		},
		sortOrgs: (a, b) => {
			let compare;

			let aIndex = DataConst.MISSION_ORG_TYPES.indexOf(a.type),
				bIndex = DataConst.MISSION_ORG_TYPES.indexOf(b.type);

			aIndex = aIndex === -1 ? DataConst.UNIT_ORG_TYPES.indexOf(a.type) + 100 : aIndex;
			bIndex = bIndex === -1 ? DataConst.UNIT_ORG_TYPES.indexOf(b.type) + 100 : bIndex;

			compare = aIndex - bIndex;

			if (compare === 0 && a.name) {
				compare = a.name.localeCompare(b.name);
			}

			return compare;
		},

		isBoundaryStatusHigher: (a, b) => (
			DataConst.BOUNDARY_STATUS.indexOf(a) > DataConst.BOUNDARY_STATUS.indexOf(b)
		),
		isUnit: (org) => (
			DataConst.UNIT_ORG_TYPES.indexOf(org.type || org) !== -1
		),
		isAssignedUnits: (type) => (
			type === "AREA" || utils.isUnit(type)
		),
		getOrgBounds: (org) => (
			utils.getOrgExtendedProp(org, "bounds")
		),
		getOrgBoundary: (org) => (
			utils.getOrgExtendedProp(org, "boundary")
		),
		getOrgExtendedProp: (org, prop) => {
			let value = null;
			if (org) {
				value = org[prop] || null;
				if (org.extended) {
					value = org.extended[prop] || value;
				}
			}
			return value;
		},
		allPromisesCompleted: (promises) => {
			let d = $q.defer(),
				promiseCounter = 0;

			promises = utils.toArray(promises);

			promises.forEach((promise) => {
				promise.finally(() => {
					if (++promiseCounter === promises.length) {
						d.resolve(promises);
					}
				});
			});
			return d.promise;
		}
	};
	return utils;
}
